import React from 'react';
import { TAG } from 'shared/constants';
import useMissionsIcon from 'shared/screens/Missions/hooks/useMissionsIcon';
import { useTheme } from 'styled-components';
import { pwaStyleAdapter } from '../../../utils/mobileSupported';
import LazyImage from '../../LazyImage/LazyImage';
import Divider from './Divider';
import NotificationBadge from '../../NotificationBadge/NotificationBadge';
import notificationCalculator from 'shared/screens/Missions/utils/notificationCalculator';

const MissionsIcon = props => {
  const { BottomBar } = useTheme();
  const { showMissionsButton, missionsIcon, shouldRunMissionsAnimation, missionsState, handleMissionButton } =
    useMissionsIcon(props);

  const { missionsCount, battlesCount } = notificationCalculator(
    missionsState?.data?.missions,
    missionsState?.data?.currentCycle
  );
  const totalNotifications = missionsCount + battlesCount;
  return (
    <>
      {showMissionsButton ? (
        <>
          <Divider />
          <div
            id="MISSIONS_ICON"
            className={`BarItem ${shouldRunMissionsAnimation && 'AnimatedIcon'}`}
            style={{ pointerEvents: 'auto' }}
            onClick={handleMissionButton}
          >
            {totalNotifications > 0 && (
              <NotificationBadge
                textStyle={pwaStyleAdapter(BottomBar.NotificationText)}
                count={totalNotifications}
                theme={pwaStyleAdapter(BottomBar.NotificationMission)}
              />
            )}
            <LazyImage
              tag={TAG.IMG}
              alt="Bottom Bar"
              src={missionsIcon}
              draggable="false"
              style={pwaStyleAdapter(BottomBar.MissionsIcon)}
            />
          </div>
        </>
      ) : (
        <div style={pwaStyleAdapter(BottomBar.BarItem)} />
      )}
    </>
  );
};

export default MissionsIcon;

